import styled, { css } from "styled-components";
import { colors } from "healthex-common/colors";
import { FlexColumn, FlexColumnDiv, FlexRow } from "./common.styles";
import CheckIcon from "@mui/icons-material/Check";
import LockIcon from "@mui/icons-material/Lock";
import { SemiBoldText } from "./HXDesktopPage.styles";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { LighterText } from "./HXMobilePage.styles";
import { fontSizes } from "healthex-common/sizes";
export const LocationCardContainer = styled(FlexColumn) `
    width: 100%;
    padding: 12px;
    gap: 16px;
    border: 2px solid ${colors.blue_10};
    box-sizing: border-box;

    ${(props) => !props.isFirst && `border-top: none;`}
    ${(props) => props.isError && `padding: 12px 2px 12px 12px;`}

    border-radius: ${(props) => {
    if (props.isFirst && props.isLast)
        return "8px";
    if (props.isFirst)
        return "8px 8px 0 0";
    if (props.isLast)
        return "0 0 8px 8px";
    return "0";
}};

    ${(props) => props.isButton &&
    css `
            cursor: pointer;
            @media (hover: hover) {
                &:hover {
                    background-color: ${colors.blue_10};
                }
            }
        `}
`;
export const LocationHeader = styled(FlexRow) `
    width: 100%;
    gap: 12px;
    align-items: center;
    box-sizing: border-box;
    justify-content: space-between;
`;
export const LocationLeftContent = styled(FlexRow) `
    flex: 1;
    gap: 16px;
    align-items: center;
    min-width: 0;
`;
export const LocationLogoContainer = styled(FlexColumn) `
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 4px;
    overflow: hidden;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: 1px solid ${colors.black_12};
    box-sizing: border-box;
    align-self: center;
`;
export const LocationLogo = styled.img `
    width: 100%;
    height: 100%;
    object-fit: contain;
`;
export const LocationFallbackIcon = styled(FlexColumn) `
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 6px;
    border: 1px solid ${colors.blue_10};
    background: linear-gradient(180deg, rgba(29, 98, 174, 0.28) 0%, rgba(29, 98, 174, 0.4) 100%);
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-sizing: border-box;
    font-size: 16px;
    color: ${colors.white_main};
    text-transform: uppercase;
    align-self: center;
`;
export const LocationInfoContainer = styled(FlexColumn) `
    flex: 1;
    gap: 2px;
    min-width: 0;
    justify-content: center;
`;
export const LocationName = styled(SemiBoldText) `
    color: ${colors.black_main};
    text-align: left;
    width: 100%;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
`;
export const BaseLocationIcon = css `
    width: 20px;
    height: 20px;
    opacity: 0.7;
    color: ${colors.navy_main};
`;
export const Check = styled(CheckIcon) `
    ${BaseLocationIcon}
    aspect-ratio: 1/1;
`;
export const Error = styled(LockIcon) `
    ${BaseLocationIcon}
    flex-shrink: 0;
`;
export const ErrorContainer = styled(FlexColumnDiv) `
    height: 48px;
    width: 48px;
    justify-content: center;
    align-items: center;
`;
export const ProviderForwardIcon = styled(ArrowForwardIosIcon) `
    ${BaseLocationIcon}
    aspect-ratio: 1/1;
`;
export const ProviderText = styled(LighterText) `
    font-size: ${fontSizes.LITTLE};
    letter-spacing: normal;
    text-align: left;
`;
export const LocationSubtitle = styled.p `
    font-size: ${fontSizes.LITTLE};
    color: ${colors.black_light};
    text-align: left;
    margin: 0;
`;
